var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var APIHTTPDataSource_1;
import { injectable } from '../../Decorators/Injectable';
import { Observable } from '../../Observable/Observable';
import axios from 'axios';
import mime from 'mime';
import { getNetworkStateAsync } from 'expo-network';
import { Platform } from 'react-native';
import { CoreConstants } from '../../../CoreConfig';
let APIHTTPDataSource = APIHTTPDataSource_1 = class APIHTTPDataSource {
    static get httpClient() {
        return APIHTTPDataSource_1._httpClient;
    }
    static errorHandler(error) { }
    static setErrorHandler(fn) {
        APIHTTPDataSource_1.errorHandler = fn;
    }
    static setHTTPClient(httpClient) {
        APIHTTPDataSource_1._httpClient = httpClient;
    }
    constructor(configuration = {}) {
        this.configuration = configuration;
        this.disableRequests = false;
        this.onLogExceptionError = [];
        this.debugMessages = new Observable();
        this.interceptor = new Observable();
        this.interceptor.observe(this, response => {
            if (response.error && response.error.length > 0) {
                response.error.forEach(error => {
                    APIHTTPDataSource_1.errorHandler(error);
                });
            }
        });
    }
    setMaintenanceMode(value) {
        this.disableRequests = value;
    }
    addOnLogExceptionErrorHandler(fn) {
        this.onLogExceptionError.push(fn);
        return () => {
            this.onLogExceptionError = this.onLogExceptionError.filter(cb => cb !== fn);
        };
    }
    addInterceptor(fn) {
        const sub = this.interceptor.subscribe(value => fn(value));
        return () => sub.unsubscribe();
    }
    setOnInvalidAuthorization(fn) {
        this.onInvalidAuthorization = fn;
    }
    setOnMaintenanceMode(fn) {
        this.onMaintenanceMode = fn;
    }
    setOnOfflineMode(fn) {
        this.onOfflineMode = fn;
    }
    mock() {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { mocked: true });
        return this.configuration;
    }
    unmock() {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { mocked: false });
        return this.configuration;
    }
    setLocalization(localization) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { localization });
        return this.configuration;
    }
    setLanguage(language) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { language });
        return this.configuration;
    }
    setAPIVersion(apiVersion) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { apiVersion });
        return this.configuration;
    }
    setBehavior(behavior) {
        return this.setConfiguration({ behavior });
    }
    setNamespace(namespace) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { namespace });
        return this.configuration;
    }
    setServerURL(serverUrl) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { serverUrl });
        return this.configuration;
    }
    setSID(sid) {
        return this.setConfiguration({ sid });
    }
    setLastSID(lastSid) {
        return this.setConfiguration({ lastSid });
    }
    setDevice(device) {
        return this.setConfiguration({ device });
    }
    setApplicationBuild(applicationBuild) {
        return this.setConfiguration({ applicationBuild });
    }
    setReactBuild(reactBuild) {
        return this.setConfiguration({ reactBuild });
    }
    setProfile(profile) {
        return this.setConfiguration({ profile });
    }
    setApplicationToken(applicationToken) {
        return this.setConfiguration({ applicationToken });
    }
    setConfiguration(configuration) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), configuration);
        return this.configuration;
    }
    get(params) {
        this.addBehaviorToRequest([params]);
        return this.request(Object.assign({ method: 'GET' }, params));
    }
    post(params) {
        return this.request(Object.assign({ method: 'POST' }, params));
    }
    batchGet(params) {
        this.addBehaviorToRequest(params);
        return this.batchRequest(params.map(value => (Object.assign({ method: 'GET' }, value))));
    }
    batchPost(params) {
        return this.batchRequest(params.map(value => (Object.assign({ method: 'POST' }, value))));
    }
    batchDelete(params) {
        return this.batchRequest(params.map(value => (Object.assign({ method: 'DELETE' }, value))));
    }
    delete(params) {
        return this.request(Object.assign({ method: 'DELETE' }, params));
    }
    createError(code, message = 'Something went wrong') {
        return { error: [{ message, code }] };
    }
    getServerParams(namespace, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (this.configuration.mocked && !namespace.startsWith('mock')) {
            namespace = `mock/${namespace}`;
        }
        let serverUrl = ((_b = (_a = this.configuration) === null || _a === void 0 ? void 0 : _a.serverUrl) === null || _b === void 0 ? void 0 : _b.replace(/^\/+|\/$/gm, '')) || '';
        if (serverUrl.endsWith('/')) {
            serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        }
        if (!serverUrl.includes('/api')) {
            serverUrl += '/api';
        }
        if (!serverUrl.includes('/api/v')) {
            serverUrl += `/${this.configuration.apiVersion || 'v2.2'}`;
        }
        serverUrl += '/';
        const url = serverUrl + namespace;
        const config = Object.assign(Object.assign({}, options), { headers: {} });
        config.headers['X-Date'] = Date.now();
        if ((_c = this.configuration) === null || _c === void 0 ? void 0 : _c.sid) {
            config.headers.Authorization = this.configuration.sid;
        }
        if ((_d = this.configuration) === null || _d === void 0 ? void 0 : _d.applicationToken) {
            config.headers['X-Application'] = this.configuration.applicationToken;
        }
        if ((_e = this.configuration) === null || _e === void 0 ? void 0 : _e.lastSid) {
            config.headers['X-Last-Authorization'] = this.configuration.lastSid;
        }
        if ((_f = this.configuration) === null || _f === void 0 ? void 0 : _f.device) {
            config.headers['X-Device'] = this.configuration.device;
        }
        if ((_g = this.configuration) === null || _g === void 0 ? void 0 : _g.applicationBuild) {
            config.headers['X-Application-Build'] = this.configuration.applicationBuild;
        }
        if ((_h = this.configuration) === null || _h === void 0 ? void 0 : _h.reactBuild) {
            config.headers['X-React-Build'] = this.configuration.reactBuild;
        }
        if ((_j = this.configuration) === null || _j === void 0 ? void 0 : _j.profile) {
            config.headers['X-Profile'] = this.configuration.profile;
        }
        if ((_k = this.configuration) === null || _k === void 0 ? void 0 : _k.language) {
            config.headers['X-Language'] = this.configuration.language;
        }
        return { url, config };
    }
    uploadFile(uri, options) {
        const { url, config } = this.getServerParams('shared/upload_file', options);
        config.headers['Content-Type'] = 'multipart/form-data';
        config.transformRequest = (d) => d;
        return Promise.resolve(Platform.OS === 'web')
            .then(isWeb => {
            return isWeb
                ? fetch(uri).then(res => res.blob())
                : {
                    uri,
                    name: uri.split('/').pop(),
                    type: mime.getType(uri)
                };
        })
            .then((blob) => {
            const data = new FormData();
            data.append('file', blob);
            return APIHTTPDataSource_1.httpClient.post(url, data, config);
        })
            .then(response => this.sterilization(response));
    }
    sterilization(response) {
        var _a;
        if (response.statusText !== 'OK' && (response.status < 200 || response.status > 299)) {
            return Promise.reject(new Error(response.statusText || response.status.toString()));
        }
        let data = this.createError(-1);
        if (response.data.responses) {
            data = response.data.responses[0];
        }
        else if (response.data.data) {
            data = response.data.data;
        }
        data.meta = response.data.meta;
        if (data.error) {
            this.fireInterceptors(data);
            return Promise.reject((_a = data.error) === null || _a === void 0 ? void 0 : _a[0]);
        }
        this.fireInterceptors(data);
        return Promise.resolve(data);
    }
    handleError(timeout, error) {
        var _a, _b;
        if (timeout == null) {
            error.code = CoreConstants.errors.request_timeout;
            error.message = 'Request timeout';
        }
        if (error.code === CoreConstants.errors.unauthorized || error.message.toLowerCase() === 'invalid authorization') {
            (_a = this.onInvalidAuthorization) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        if (error.code === 'ERR_NETWORK' || error.code === CoreConstants.errors.service_unavailable) {
            error.code = CoreConstants.errors.maintenance;
            (_b = this.onMaintenanceMode) === null || _b === void 0 ? void 0 : _b.call(this, true);
        }
        return Promise.reject(error);
    }
    addBehaviorToRequest(data) {
        if (!this.configuration.behavior) {
            return;
        }
        data.forEach(request => {
            if (!request.params) {
                request.params = {};
            }
            if (!request.params.query) {
                request.params.query = {};
            }
            request.params.query.behavior = this.configuration.behavior;
        });
    }
    request(params) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.disableRequests) {
                const error = new Error(((_a = this.configuration.localization) === null || _a === void 0 ? void 0 : _a.maintenance_error) || 'Application is in maintenance mode!');
                error.code = CoreConstants.errors.maintenance;
                return Promise.reject(error);
            }
            const networkStatus = yield getNetworkStateAsync().catch(error => ({ isConnected: true }));
            if (!networkStatus.isConnected) {
                const error = new Error(((_b = this.configuration.localization) === null || _b === void 0 ? void 0 : _b.offline_error) || 'Application is in offline mode!');
                error.code = CoreConstants.errors.offline;
                (_c = this.onOfflineMode) === null || _c === void 0 ? void 0 : _c.call(this, true);
                return Promise.reject(error);
            }
            (_d = this.onOfflineMode) === null || _d === void 0 ? void 0 : _d.call(this, false);
            if (!params.ac) {
                params.ac = new AbortController();
            }
            const { url, config } = this.getServerParams(params.namespace || this.configuration.namespace || '');
            const timeout = 15000;
            const data = {
                requests: [
                    {
                        method: params.method,
                        path: params.path,
                        params: params.params,
                        data: params.data
                    }
                ]
            };
            let id = setTimeout(() => {
                id = null;
                params.ac.abort();
            }, timeout);
            return APIHTTPDataSource_1.httpClient.post(url, data, config)
                .then(response => this.sterilization(response))
                .then(result => {
                var _a;
                this.logCurl(url, data, config, result);
                (_a = this.onMaintenanceMode) === null || _a === void 0 ? void 0 : _a.call(this, false);
                return result;
            })
                .catch(error => {
                this.logCurl(url, data, config, error);
                params.path !== 'exceptions' && this.logException({
                    path: params.path,
                    namespace: params.namespace,
                    exception: error.code,
                    message: error.message,
                    body: {
                        request: data,
                        response: error
                    },
                    external_identifier: !error.code
                        ? 'JS'
                        : undefined
                });
                return this.handleError(id, error);
            })
                .finally(() => id && clearTimeout(id));
        });
    }
    batchSterilization(response, params) {
        if (response.statusText !== 'OK' && (response.status < 200 || response.status > 299)) {
            return Promise.reject(response.status);
        }
        const responses = response.data.responses || [];
        if (responses.length !== params.length) {
            return Promise.reject(new Error('Length of responses don\'t match length of requests!'));
        }
        const data = {
            responses,
            hasError: !!responses.find(x => { var _a; return !!((_a = x.error) === null || _a === void 0 ? void 0 : _a[0]); })
        };
        return Promise.resolve(data);
    }
    batchRequest(params) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.disableRequests) {
                const error = new Error(((_a = this.configuration.localization) === null || _a === void 0 ? void 0 : _a.maintenance_error) || 'Application is in maintenance mode!');
                error.code = CoreConstants.errors.maintenance;
                return Promise.reject(error);
            }
            const networkStatus = yield getNetworkStateAsync().catch(error => ({ isConnected: true }));
            if (!networkStatus.isConnected) {
                const error = new Error(((_b = this.configuration.localization) === null || _b === void 0 ? void 0 : _b.offline_error) || 'Application is in offline mode!');
                error.code = CoreConstants.errors.offline;
                (_c = this.onOfflineMode) === null || _c === void 0 ? void 0 : _c.call(this, true);
                return Promise.reject(error);
            }
            (_d = this.onOfflineMode) === null || _d === void 0 ? void 0 : _d.call(this, false);
            const ac = new AbortController();
            const { url, config } = this.getServerParams(this.configuration.namespace || '');
            const timeout = 15000;
            const data = {
                requests: params.map(value => ({
                    method: value.method,
                    path: value.path,
                    params: value.params,
                    data: value.data
                }))
            };
            let id = setTimeout(() => {
                id = null;
                ac.abort();
            }, timeout);
            return APIHTTPDataSource_1.httpClient.post(url, data, config)
                .then(response => this.batchSterilization(response, params))
                .then(result => {
                var _a;
                this.logCurl(url, data, config, result);
                (_a = this.onMaintenanceMode) === null || _a === void 0 ? void 0 : _a.call(this, false);
                if (result.hasError && !params.find(x => x.path === 'exceptions')) {
                    const errors = params.reduce((acc, value, i) => {
                        var _a, _b, _c, _d, _e, _f;
                        if ((_a = result.responses[i].error) === null || _a === void 0 ? void 0 : _a[0]) {
                            this.handleError(null, (_b = result.responses[i].error) === null || _b === void 0 ? void 0 : _b[0]).catch(() => { });
                            acc.push({
                                path: value.path,
                                namespace: value.namespace,
                                exception: (_d = (_c = result.responses[i].error) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.code,
                                message: (_f = (_e = result.responses[i].error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.message,
                                body: {
                                    request: data,
                                    response: result.responses[i]
                                }
                            });
                        }
                        return acc;
                    }, []);
                    this.batchLogException(errors);
                }
                return result;
            })
                .catch(error => {
                this.logCurl(url, data, config, error);
                this.logException({
                    path: '',
                    exception: error.code,
                    message: error.message,
                    body: {
                        request: data,
                        response: error
                    },
                    external_identifier: !error.code
                        ? 'JS'
                        : undefined
                });
                return this.handleError(id, error);
            })
                .finally(() => id && clearTimeout(id));
        });
    }
    batchLogException(params, disable_submit_error) {
        const { url, config } = this.getServerParams(this.configuration.namespace || '');
        const data = {
            requests: params.map(value => ({
                method: 'POST',
                path: 'exceptions',
                data: Object.assign(Object.assign({}, value), { path: url, namespace: undefined })
            }))
        };
        return APIHTTPDataSource_1.httpClient.post(url, data, config)
            .then(() => true)
            .catch(() => {
            !disable_submit_error && this.onLogExceptionError.forEach(fn => fn(params));
            return false;
        });
    }
    logException(params) {
        const { url, config } = this.getServerParams(params.namespace || this.configuration.namespace || '');
        const data = {
            requests: [
                {
                    method: 'POST',
                    path: 'exceptions',
                    data: Object.assign(Object.assign({}, params), { path: url, namespace: undefined })
                }
            ]
        };
        return APIHTTPDataSource_1.httpClient.post(url, data, config)
            .then(() => true)
            .catch(() => {
            this.onLogExceptionError.forEach(fn => fn([params]));
            return false;
        });
    }
    logCurl(url, data, config, response) {
        var _a;
        this.debugMessages.next({
            type: 'request',
            data: {
                curl: `curl -X POST ${url} \n ${Object.entries(config.headers || {}).reduce((acc, [key, value]) => `${acc}${acc ? ' \n ' : ''}-H '${key}: ${value}'`, '')} ${((_a = config.headers) === null || _a === void 0 ? void 0 : _a['Content-Type']) ? '' : `\n -H 'Content-Type: application/json'`} \n -d '${JSON.stringify(data)}'`,
                response
            }
        });
    }
    fireInterceptors(response) {
        this.interceptor.next(response);
    }
};
APIHTTPDataSource._httpClient = axios;
APIHTTPDataSource = APIHTTPDataSource_1 = __decorate([
    injectable({ type: 'singleton' }),
    __metadata("design:paramtypes", [Object])
], APIHTTPDataSource);
export { APIHTTPDataSource };
